<div class="chats-list-wrapper" [@showChatsPanel]="showChatsListPanel">
  <div class="chats-list-toggle-button" (click)="toggleChatsPanel()">
    <nz-badge [nzCount]="unreadCount$ | async" [nzStandalone]="true"></nz-badge>
    <mat-icon *ngIf="showChatsListPanel">chevron_right</mat-icon>
    <mat-icon *ngIf="!showChatsListPanel">chevron_left</mat-icon>
  </div>

  <ng-container *ngIf="isMinimized | async">
    <div
      class="chats-list-minimize-button"
      (click)="toggleChatsPanelMinimize()"
      *ngIf="openSupportChat$ | async as openSupportChat">
      <nz-badge [nzCount]="unreadMessagesCount$ | async" [nzStandalone]="true"></nz-badge>
      <div class="minified-chat-avatar">
        <app-cr-avatar
          [userName]="openSupportChat.supportChat.supportedUser.name"
          [theme]="'THEME-2'"
          [size]="'M'"></app-cr-avatar>
      </div>
    </div>
  </ng-container>

  <div
    class="chats-inner-wrapper"
    [attr.inert]="showChatsListPanel ? null : ''"
    [attr.aria-hidden]="!showChatsListPanel">
    <div class="support-chat">
      <app-support-chat-desktop (searchTypeChange)="onSearchTypeChange($event)"></app-support-chat-desktop>
    </div>
  </div>
</div>
